import './Switch.css';
import React, { useEffect } from 'react';
import { canUseDOM, get, getDictionaryItem } from '../../utils';
import addQueryString, { removeQueryString, splitter } from './index';
import { useHistory, useLocation } from 'react-router-dom';
import { qsToObject } from '../../utils/querystring';
import { tealiumClickFunc, tealiumMergeClickData } from '../../utils/tealium';
import { isNil } from '../../utils/IsNil';
const replaceUrlPluses = function () {
  let str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  if (str) {
    let arr = str.split('');
    let plusIndexes = [];
    arr.forEach((item, index) => {
      if (item === '+') {
        plusIndexes.push(index);
      }
    });
    if (str.includes('+') && str.includes('%20')) {
      return str.replace(/\%20/g, ' ');
    } else {
      let newStr = str;
      let newStrArr = str.split('');
      plusIndexes.forEach((el, i) => {
        // 5++days -> 5+ days
        if (el + 1 === plusIndexes[i + 1]) {
          newStrArr[el + 1] = ' ';
          newStr = newStrArr.join('');
          // 1+day -> 1 day
        } else if (plusIndexes.length === 1 && newStrArr[el + 1] !== ' ') {
          newStrArr[el] = ' ';
          newStr = newStrArr.join('');
          // 5+ day
        } else if (plusIndexes.length === 1 && newStrArr[el + 1] === ' ') {
          return str;
        }
        //business+events;,leisure+events;art+&+events
        else {
          newStrArr[el] = ' ';
          newStr = newStrArr.join('');
        }
      });
      return newStr;
    }
  }
  return str;
};
export const createFacets = (facets, allTagLabel) => {
  let filteredOptions = [];
  let allLabelSum = 0;
  if (facets) {
    filteredOptions = Object.keys(facets).map(item => ({
      key: item,
      label: facets[item],
      name: item
    }));
    allLabelSum = filteredOptions.reduce((acc, current) => current.label + acc, 0);
  }
  filteredOptions.unshift({
    key: allTagLabel,
    label: allLabelSum,
    name: allTagLabel
  });
  return filteredOptions.length !== 0 ? filteredOptions : undefined;
};
const Switch = _ref => {
  let {
    fields,
    facets,
    setFilter,
    facetsName,
    clearAlllFilters,
    dictionary,
    allTagLabel,
    buttonsDictionary,
    analytics,
    setIsTypeSetToUrl,
    getFilterValue,
    rtl,
    resetAllFiltersCallback,
    autoWidth
  } = _ref;
  const location = useLocation();
  const queryParams = qsToObject(location.search);
  const selectedTagsToDisplay = get(fields, 'preselectedTags.values');
  const filterName = get(fields, 'name');
  const [filteredOptions, _] = React.useState(canUseDOM ? createFacets(facets, allTagLabel) : []);
  const filterType = get(fields, 'fieldNameItem.item.fieldName.value');
  const type = get(fields, 'fieldTypeItem.item.fieldType.value') === 'Toggle Single Select' ? 'radio' : 'checkbox';
  let history = useHistory();
  const checkboxes = React.useRef();
  useEffect(() => {
    if (clearAlllFilters) {
      if (selectedTagsToDisplay && selectedTagsToDisplay.length !== 0) {
        const preselectedTags = selectedTagsToDisplay.map(tag => get(tag, 'title.value') || get(tag, 'name'));
        addQueryString(facetsName, replaceUrlPluses(preselectedTags.join(',')), history);
        getFilterValue && getFilterValue(fields.name, facetsName, replaceUrlPluses(preselectedTags.join(',')));
        setFilter();
        resetAllFiltersCallback();
      } else {
        const checkboxesArray = checkboxes.current.querySelectorAll('.fp__checkbox');
        for (let i = 0; i <= checkboxesArray.length - 1; i++) {
          checkboxesArray[i].checked = false;
        }
        removeQueryString(facetsName, history);
        getFilterValue && getFilterValue(fields.name, facetsName, null);
      }
    }
  }, [clearAlllFilters]);
  useEffect(() => {
    const queries = queryParams[`${filterType}`];
    if (selectedTagsToDisplay && selectedTagsToDisplay.length !== 0) {
      const preselectedTags = selectedTagsToDisplay.map(tag => get(tag, 'title.value') || get(tag, 'name'));
      if (!queries) {
        addQueryString(facetsName, replaceUrlPluses(preselectedTags.join(',')), history);
        setFilter(true);
      }
    }
  }, []);
  const addNewQueryString = () => {
    const queries = queryParams[`${filterType}`];
    if (!queries && filteredOptions && filteredOptions.length) {
      addQueryString(facetsName, filteredOptions[0].key, history);
      setIsTypeSetToUrl(true);
    }
  };
  const buttonHistoryHandler = () => {
    const urlParams = new URLSearchParams(canUseDOM ? window.location.search : undefined);
    const typeFromUrl = urlParams.get('type');
    if (isNil(typeFromUrl)) {
      addNewQueryString();
    }
  };
  useEffect(() => {
    addNewQueryString();
  }, [filteredOptions]);
  useEffect(() => {
    if (canUseDOM) {
      window.addEventListener('popstate', buttonHistoryHandler);
    }
    return () => {
      removeQueryString(facetsName, history);
      window.addEventListener('popstate', buttonHistoryHandler);
    };
  }, []);
  const setChecked = (key, filterType, index) => {
    let queries = queryParams[`${filterType}`];
    queries = queries && replaceUrlPluses(queries);
    let isChecked = false;
    if (index === 0 && !queries) {
      addQueryString(facetsName, replaceUrlPluses(key), history);
      setFilter();
      isChecked = true;
    }
    queries && queries.split(';,;').map(item => {
      if (replaceUrlPluses(item) === key) {
        isChecked = true;
      }
    });
    return isChecked;
  };
  const translatedKey = key => getDictionaryItem(dictionary, `Type.${key}`) || getDictionaryItem(dictionary, key) || key;
  const submitFilters = e => {
    const checkboxesArray = checkboxes.current.querySelectorAll('.fp__checkbox');
    let selectedCheckboxes = [];
    for (let i = 0; i <= checkboxesArray.length - 1; i++) {
      if (checkboxesArray[i].checked) {
        selectedCheckboxes.push(checkboxesArray[i].value);
      }
    }
    selectedCheckboxes = selectedCheckboxes.join(splitter);
    addQueryString(facetsName, replaceUrlPluses(selectedCheckboxes), history);
    setFilter();
    getFilterValue && getFilterValue(fields.name, facetsName, replaceUrlPluses(selectedCheckboxes));
  };
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    autoWidth: autoWidth
  }, /*#__PURE__*/React.createElement("div", {
    className: "filter-toggle-multi-select switch"
  }, /*#__PURE__*/React.createElement("div", {
    ref: checkboxes,
    className: `g-checkbox g-checkbox--mob-scroll ${type === 'radio' ? 'g-checkbox-notick' : ''}`
  }, filteredOptions && filteredOptions.map((item, index) => {
    const {
      key
    } = item;
    return /*#__PURE__*/React.createElement("div", {
      key: key + index,
      className: "g-checkbox__item"
    }, /*#__PURE__*/React.createElement("input", {
      tabIndex: 0,
      value: key,
      defaultChecked: setChecked(key, filterType, index),
      checked: setChecked(key, filterType, index),
      type: type,
      className: `fp__checkbox`,
      id: `gct1-${key + index}`,
      name: "gct1",
      title: translatedKey(key),
      onChange: e => {
        tealiumClickFunc(tealiumMergeClickData(analytics.filterAnalytics, analytics.params), `${filterName}: ${key} `);
        submitFilters(e);
      },
      onKeyPress: event => {
        if (event.key === 'Enter' || event.key === 'NumpadEnter') {
          event.preventDefault();
          event.target.checked = !event.target.checked;
          tealiumClickFunc(tealiumMergeClickData(analytics.filterAnalytics, analytics.params), `${filterName}: ${key} `);
          submitFilters(event);
        }
      }
    }), /*#__PURE__*/React.createElement("label", {
      className: "body-small g-checkbox__label",
      htmlFor: `gct1-${key + index}`
    }, translatedKey(key)));
  }))));
};
const StyledWrapper = _ref2 => {
  let {
    children,
    rtl,
    autoWidth = false
  } = _ref2;
  return /*#__PURE__*/React.createElement("div", {
    className: `${commonStyles} ${rtl ? rtlStyle : ltrStyle}`
  }, children);
};
export default Switch;
export const commonStyles = "cz6cwl0";
const ltrStyle = "l1atgt1g";
const rtlStyle = "rf0wazi";